class Product extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
    }
  }

  connectedCallback() {
    this.removeFirstReviewForm();
  }

  removeFirstReviewForm() {
    this.waitForElm('.new-review-form').then((element) => {
        element.remove();
    });
    this.waitForElm('.stamped-header-title').then((element) => {
        element.remove();
    });
    this.waitForElm('.stamped-header').then((element) => {
        element.remove();
    });
    this.waitForElm('.stamped-tab-container').then((element) => {
        element.remove();
    });
    this.waitForElm('.stamped-messages').then((element) => {
        element.remove();
    });
    this.waitForElm('.stamped-reviews-filter').then((element) => {
        element.remove();
    });
    this.waitForElm('.stamped-questions').then((element) => {
        element.remove();
    });
    this.waitForElm('.stamped-pagination').then((element) => {
        element.remove();
    });
  }

  waitForElm(selector) {
      return new Promise(resolve => {
          if (document.querySelector(selector)) {
              return resolve(document.querySelector(selector));
          }
          const observer = new MutationObserver(mutations => {
              if (document.querySelector(selector)) {
                  observer.disconnect();
                  resolve(document.querySelector(selector));
              }
          });
          observer.observe(document.body, {
              childList: true,
              subtree: true
          });
      });
  }
}

customElements.define('section-product', Product)